// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OrderAttributeCheckbox-module-checkoutLabel-Xpp1R{font-weight:var(--weight-light);letter-spacing:0;line-height:23px;color:#5b615e}.OrderAttributeCheckbox-module-checkoutLabel-Xpp1R div{font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkoutLabel": "OrderAttributeCheckbox-module-checkoutLabel-Xpp1R"
};
export default ___CSS_LOADER_EXPORT___;
